// Unified version-aware client factory
export type { EvoVersion, UnifiedEvoClientParams } from "./createEvoClient";
export { createEvoClient, getClientVersion } from "./createEvoClient";

// Re-export EvoClientParams for backward compatibility
export type { EvoClientParams } from "../shared/createEvoClient";

// Shared utilities
export { X_BRAND_HEADER, X_DES_ORG_BRAND_HEADER } from "../shared/createEvoClient";
export { sanitizeBaseUrl } from "../shared/sanitizeBaseUrl";

// Version dispatch helpers (for consumers that need to build custom wrappers)
export { createAdaptedFunction, createV6OnlyFunction, createVersionedFunction } from "./versionedFunction";

// All unified SDK function wrappers (v5 names as canonical API)
export * from "./sdk";

// All v5 types as canonical types (structurally identical to v6).
// Re-export only types — SDK functions come from ./sdk with version dispatch.
export type { Options } from "../v5/__generated__/sdk.gen";
export * from "../v5/__generated__/types.gen";
